import commonMessages from '@rhg/lang/messages/common';
import { Typography } from '@rhg/libs/material';
import Head from 'next/head';
import React from 'react';
import { useIntl } from 'react-intl';

export interface PageTitleProps {
    title: string;
    children?: React.ReactElement | React.ReactElement[];
    /**
     * When `true`, displays an sr-only h1 using the value of `title` for the text. (default: false)
     */
    showSrOnlyH1?: boolean;
}
export const PageTitle = ({
    title,
    children,
    showSrOnlyH1 = false,
}: PageTitleProps) => {
    const { formatMessage } = useIntl();
    return (
        <>
            <Head>
                <title>{`${title} - ${formatMessage(
                    commonMessages['common.brand_name']
                )}`}</title>
                {children}
            </Head>
            {showSrOnlyH1 && (
                <Typography variant="srOnly" component="h1">
                    {title}
                </Typography>
            )}
        </>
    );
};

export default PageTitle;
